<div class="cliente-analise-mercado-filter">
    
    <div class="cliente-analise-mercado-filter-quick-row">           
        <!-- Classificações RAP --> 
        <div class="cliente-analise-mercado-filter-quick-block">
            <sgt-classificacao-faturamento-multiselect
                [(ngModel)]="filter.idsClassificacoesRAP"
                (ngModelChange)="onChangeClassificacoesRAP()">
            </sgt-classificacao-faturamento-multiselect>  
        </div>

        <!-- Indicadores Customer Share RAP --> 
        <div class="cliente-analise-mercado-filter-quick-block">
            <sgt-customer-share-indicador-multiselect
                [(indicadores)]="filter.indicadoresCustomerShareRAP"
                (indicadoresChange)="onChangeIndicadoresCustomerShareRAP()"
                defaultTitle="Customer Share RAP"
                checked="Customer Share RAP"
                checkedPlural="Customer Share RAP">
            </sgt-customer-share-indicador-multiselect>            
        </div>        

        <!-- Indicadores Customer Share RAR --> 
        <div class="cliente-analise-mercado-filter-quick-block">
            <sgt-customer-share-indicador-multiselect
                [(indicadores)]="filter.indicadoresCustomerShareRAR"
                (indicadoresChange)="onChangeIndicadoresCustomerShareRAR()"
                defaultTitle="Customer Share RAR"
                checked="Customer Share RAR"
                checkedPlural="Customer Share RAR">
            </sgt-customer-share-indicador-multiselect>            
        </div>                

        <!-- Meta -->
        <div class="cliente-analise-mercado-filter-quick-block cliente-analise-mercado-filter-quick-block-meta" *ngIf="isShowMeta()">
            <sgt-meta-multiselect
                #metaMultiselect
                [(idsMetas)]="filter.idsMetas"
                (idsMetasChange)="onChangeMeta()"
                [showCheckAll]="false"
                [showUncheckAll]="false"
                [dynamicTitleMaxItems]="1"
                [selectionLimit]="1"
                [autoUnselect]="true"
                [closeOnSelect]="true"
                [searchOnInit]="false"
                [disabled]="!isFilterInitialized">
            </sgt-meta-multiselect>
        </div>

        <!-- Cadastros de Clientes -->
        <div class="cliente-analise-mercado-filter-quick-block">
            <sgt-cliente-cadastro-multiselect
                [(cadastros)]="filter.cadastrosClientes"
                (cadastrosChange)="onChangeCadastrosClientes()"
                defaultTitle="Cadastros"
                [disabled]="!isFilterInitialized">
            </sgt-cliente-cadastro-multiselect>
        </div>

        <!-- Situações de Clientes -->
        <div class="cliente-analise-mercado-filter-quick-block">
            <sgt-cliente-situacao-multiselect
                [(situacoes)]="filter.situacoesClientes"
                (situacoesChange)="onChangeSituacoesClientes()"
                [cadastros]="filter.cadastrosClientes"
                defaultTitle="Situações"
                [disabled]="!isFilterInitialized">
            </sgt-cliente-situacao-multiselect>         
        </div>

        <!-- Classificações de Clientes -->
        <div class="cliente-analise-mercado-filter-quick-block">
            <sgt-classificacao-tipo-multiselect
                [(idsClassificacoes)]="filter.idsClassificacoesClientes"
                (idsClassificacoesChange)="onChangeClassificacoesClientes()"
                [(nullOption)]="filter.classificacaoClienteNull"
                [showNullOption]="true"
                [tipoClassificacaoCadastroCliente]="true"
                defaultTitle="Segmentos"
                [disabled]="!isFilterInitialized">
            </sgt-classificacao-tipo-multiselect>                
        </div>        

        <ng-template [ngIf]="isPerspectivaClassificacao() || isPerspectivaProjetada()">
            <!-- Grupos de Classificações -->
            <div class="cliente-analise-mercado-filter-quick-block">
                <sgt-grupo-classificacao-multiselect
                    [(idsGruposClassificacoes)]="filter.idsGruposClassificacoes"
                    (idsGruposClassificacoesChange)="onChangeGruposClassificacoes()"
                    [dynamicTitleMaxItems]="10"
                    [considerarClienteAnaliseMercado]="true"
                    [selectionLimit]="isPerspectivaProjetada() ? 1 : 0"
                    [autoUnselect]="isPerspectivaProjetada() ?  true : false"
                    [closeOnSelect]="isPerspectivaProjetada() ?  true : false"                    
                    (onDestroy)="onDestroyGruposClassificacoes()">
                </sgt-grupo-classificacao-multiselect>
            </div>
    
            <!-- Classificações -->
            <div class="cliente-analise-mercado-filter-quick-block" *ngIf="isShowClassificacoes()">
                <sgt-classificacao-tipo-multiselect
                    [(idsClassificacoes)]="filter.idsClassificacoes"
                    (idsClassificacoesChange)="onChangeClassificacoes()"
                    [(nullOption)]="filter.classificacaoNull"
                    [showNullOption]="true"
                    [tipoClassificacaoCadastroItem]="true"
                    (onDestroy)="onDestroyClassificacoes()">
                </sgt-classificacao-tipo-multiselect>
            </div>

        </ng-template>
        
        <!-- Status Pretendidos -->
        <ng-template [ngIf]="isPerspectivaClassificacao()">
            <sgt-cliente-analise-mercado-status-pretendido-multiselect
                [(statusPretendidos)]="filter.statusPretendidos"
                (statusPretendidosChange)="onChangeStatusPretendidos()"
                [disabled]="!isFilterInitialized">
            </sgt-cliente-analise-mercado-status-pretendido-multiselect>
        </ng-template>

        <!-- Status Lançamentos Projetados -->
        <div class="cliente-analise-mercado-filter-quick-block" *ngIf="isPerspectivaProjetadaOuMeta()">
            <sgt-cliente-analise-mercado-status-projetado-multiselect
                [(statusProjetados)]="filter.statusProjetados"
                (statusProjetadosChange)="onChangeStatusProjetados()"
                [disabled]="!isFilterInitialized">
            </sgt-cliente-analise-mercado-status-projetado-multiselect>
        </div>


        <ng-template [ngIf]="isShowRepresentantesFilter">
            <!-- Representante -->
            <div class="cliente-analise-mercado-filter-quick-block" *ngIf="!isRepresentante">
                <sgt-representante-multiselect
                    [(idsRepresentantes)]="filter.idsRepresentantes"
                    (idsRepresentantesChange)="onChangeRepresentantes()"
                    defaultTitle="Representantes"
                    [(somenteAtivos)]="filter.somenteRepresentantesAtivos"
                    [disabled]="!isFilterInitialized">
                </sgt-representante-multiselect>      
            </div> 
            
             <!-- Atendentes -->
             <div class="cliente-analise-mercado-filter-quick-block" *ngIf="isAdministrador">
                <sgt-usuario-atendente-multiselect
                    [(idsAtendentes)]="filter.idsAtendentes"
                    (idsAtendentesChange)="onChangeAtendentes()"
                    [somenteAtivos]="true"
                    defaultTitle="Atendentes"
                    [pullRight]="true"
                    [disabled]="!isFilterInitialized">
                </sgt-usuario-atendente-multiselect>  
            </div>
        </ng-template>
    </div>  
    
    <div class="cliente-analise-mercado-filter-quick-row">
        <div class="cliente-analise-mercado-filter-quick-block cliente-analise-mercado-filter-quick-block-filter-psq" *ngIf="isShowFilterPsq()">
            <input type="text" class="form-control" [(ngModel)]="filter.filterPsq"  #filterPsq="ngModel" name="filterPsq" id="filterPsq" placeholder="Digite para pesquisar..."
                [disabled]="!isFilterInitialized" [readOnly]="!isFilterInitialized">
        </div>        

        <div class="cliente-analise-mercado-filter-quick-block cliente-analise-mercado-filter-quick-block-btns">
            <div class="btn-group">
                <button type="button" class="btn btn-light" (click)="refresh()" title="Atualizar"
                    [disabled]="!isFilterInitialized">
                    <i class="fas fa-sync"></i>
                </button>
                <button type="button" class="btn btn-light" (click)="clear()" title="Limpar filtro e atualizar"
                    [disabled]="!isFilterInitialized">
                    <i class="fas fa-eraser" aria-hidden="true"></i>
                </button>
                <button type="button" class="btn" [class.btn-light]="!filter.isFilterDirty" [class.btn-danger]="filter.isFilterDirty"
                    (click)="toggleCollapse()" title="Filtro avançado"
                    [disabled]="!isFilterInitialized">
                    <ng-template [ngIf]="isFilterInitialized">
                        <i class="fas fa-filter" aria-hidden="true"></i>
                        <i [class]="collapseIcon" aria-hidden="true"></i>
                    </ng-template>
                    <ng-template [ngIf]="isFilterInitializing">
                        <i class='fas fa-spinner fa-pulse'></i>
                    </ng-template>
                </button>
            </div>     
        </div> 
    </div>


    <div class="cliente-analise-mercado-filter-collapse" #filterCollapse>
        <div class="row">
            <!-- <div class="form-group col-12 col-md">
                <label for="filterClientesTipos" class="col-form-label">Tipos de Cliente</label>
                <sgt-cliente-tipo-multiselect
                    [(idsClientesTipos)]="filter.idsClientesTipos"
                    (idsClientesTiposChange)="onChangeClientesTipos()"
                    [disabled]="!isFilterInitialized">
                </sgt-cliente-tipo-multiselect>
            </div>
            <div class="form-group col-12 col-md">
                <label for="filterClientesGrupos" class="col-form-label">Grupos de Cliente</label>
                <sgt-cliente-grupo-multiselect
                    [(idsClientesGrupos)]="filter.idsClientesGrupos"
                    (idsClientesGruposChange)="onChangeClientesGrupos()"
                    [disabled]="!isFilterInitialized">
                </sgt-cliente-grupo-multiselect>
            </div> -->
            <div class="form-group col-12 col-md">
                <label for="filterClientesGruposEconomicos" class="col-form-label">Grupos Econômicos</label>
                <sgt-cliente-grupo-economico-multiselect
                    [(idsClientesGruposEconomicos)]="filter.idsClientesGruposEconomicos"
                    (idsClientesGruposEconomicosChange)="onChangeClientesGruposEconomicos()"
                    [disabled]="!isFilterInitialized">
                </sgt-cliente-grupo-economico-multiselect>
            </div>            
        </div>
        <div class="row">
            <div class="form-group col-12 col-md">
                <label for="filterItensTiposClientes" class="col-form-label">Tipos de Produto</label>
                <sgt-item-tipo-multiselect
                    [(idsItensTipos)]="filter.idsItensTiposClientes"
                    (idsItensTiposChange)="onChangeItensTiposClientes()"
                    [disabled]="!isFilterInitialized">
                </sgt-item-tipo-multiselect>
            </div>
            <div class="form-group col-12 col-md">
                <label for="filterEstadosClientes" class="col-form-label">Estados</label>
                <sgt-estado-multiselect
                    [(idsEstados)]="filter.idsEstadosClientes"
                    (idsEstadosChange)="onChangeEstadosClientes()"
                    [disabled]="!isFilterInitialized">
                </sgt-estado-multiselect>
            </div>            
            <div class="form-group col-12 col-md">
                <label for="filterCidadeCliente" class="col-form-label">Cidade</label>
                <sgt-typeahead-cidade [(ngModel)]="filter.cidadeCliente" name="filterCidadeCliente" id="filterCidadeCliente"
                    #filterCidadeCliente="ngModel" [ngControl]="filterCidadeCliente"
                    (entitySelected)="onSelectCidadeCliente($event)" (clearEntity)="onClearCidadeCliente()">
                </sgt-typeahead-cidade>
            </div>
        </div>
        <ng-template [ngIf]="filter.cidadeCliente?.possuiSubRegioes">
            <div class="row">
                <div class="form-group col-12 col-md">
                    <label for="filterCidadesSubRegioesClientes" class="col-form-label">Sub-Regiões</label>
                    <ngx-bootstrap-multiselect
                        [settings]="multiselectCidadesSubRegioesClientesSettings"
                        [texts]="multiselectCidadesSubRegioesClientesTexts"
                        [options]="multiselectCidadesSubRegioesClientesOptions"
                        [(ngModel)]="filter.idsCidadesSubRegioesClientes"
                        (ngModelChange)="onChangeCidadesSubRegioesClientes()">
                    </ngx-bootstrap-multiselect>
                </div>
                <div class="form-group col-12 col-md">
                    <label for="filterCidadesSubRegioesBairrosClientes" class="col-form-label">Bairros</label>
                    <ngx-bootstrap-multiselect
                        [settings]="multiselectCidadesSubRegioesBairrosClientesSettings"
                        [texts]="multiselectCidadesSubRegioesBairrosClientesTexts"
                        [options]="multiselectCidadesSubRegioesBairrosClientesOptions"
                        [(ngModel)]="filter.idsCidadesSubRegioesBairrosClientes"
                        (ngModelChange)="onChangeCidadesSubRegioesBairrosClientes()">
                    </ngx-bootstrap-multiselect>
                </div>
            </div>
        </ng-template>
    </div>
</div>

